import $ from 'jquery';
import Backbone from 'backbone';
import { T_ } from '@shared/translation';
import { isValidEmail } from '@shared/utility-functions';
import { getCSRFToken } from '@shared/cookie';

export default Backbone.Model.extend({
  validate(attrs) {
    if (!attrs.email) {
      const msg = T_('Please enter a valid email address.');
      this.trigger('email:invalid', msg);
      return false;
    }

    if (!isValidEmail(this.get('email'))) {
      const msg1 = T_('Please enter a valid email address.');
      this.trigger('email:invalid', msg1);
      return false;
    }

    this.trigger('email:valid');
    return true;
  },

  recoverPassword() {
    // Validate the model
    if (
      !this.validate({
        email: this.get('email'),
      })
    ) {
      return false;
    }

    $.ajax({
      url: '/users/ajaxonforgotpassword.php',
      context: this,
      type: 'POST',
      cache: false,
      data: {
        email: this.get('email'),
        csrf_token: getCSRFToken(),
      },
      dataType: 'JSON',
      success(msg) {
        if (msg.status == 'success') {
          this.trigger('success');
        } else {
          this.trigger('error');
        }
      },
      error() {
        this.trigger('error', T_("Error: can't connect to server"));
      },
    });
  },
});
